import { render, staticRenderFns } from "./DataTableDetailday.vue?vue&type=template&id=2097b2d7&scoped=true"
import script from "./DataTableDetailday.vue?vue&type=script&lang=js"
export * from "./DataTableDetailday.vue?vue&type=script&lang=js"
import style0 from "./DataTableDetailday.vue?vue&type=style&index=0&id=2097b2d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2097b2d7",
  null
  
)

export default component.exports